import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import { AppContexts } from "../../providers";
import { getAnnouncementFeature } from "../features/catalog";
import { SubscriptionRequirement } from "../features/shared";
import "../features/features.css";
import { getAnnouncementDate, getReleaseDate, isNewAnnouncement, safeExternalUrl } from "./model";

const AnnouncementCard = ({ announcement, dismissible = false, anchored = false }) => {
  const { user } = useContext(AppContexts.AuthContext);
  const { dismissAnnouncement } = useContext(AppContexts.AnnouncementsContext);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState("");
  const feature = getAnnouncementFeature(announcement);
  const date = getAnnouncementDate(announcement);
  const helpUrl = safeExternalUrl(announcement.link);
  const videoUrl = safeExternalUrl(announcement.video_url);
  const imageUrl = safeExternalUrl(announcement.image_url);

  const dismiss = async () => {
    if (pending) return;
    setPending(true);
    setError("");
    try {
      await dismissAnnouncement(user?.user?.user_id || user?.user_id, announcement.id);
    } catch {
      setError("We couldn’t dismiss this notice. Please try again.");
    } finally {
      setPending(false);
    }
  };

  return (
    <article id={anchored ? `announcement-${announcement.id}` : undefined} className="uk-card uk-card-default uk-card-body rbr-whats-new-card rbr-announcement-card">
      {dismissible && <button type="button" className="rbr-announcement-dismiss" disabled={pending} onClick={dismiss} aria-label={`Dismiss notice: ${announcement.title}`}>×</button>}
      {imageUrl && <img className="rbr-whats-new-image" src={imageUrl} alt="" />}
      {(feature?.category || announcement.feature_category) && <div className="rbr-whats-new-category">{feature?.category || announcement.feature_category}</div>}
      <div className="rbr-whats-new-card-header"><h2>{announcement.title}</h2>{isNewAnnouncement(announcement) && <span className="rbr-whats-new-badge">New</span>}</div>
      {date && moment(date).isValid() && <div className="rbr-whats-new-date">{getReleaseDate(announcement) ? "Released" : "Announced"}: <time dateTime={moment(date).format("YYYY-MM-DD")}>{moment(date).format("MMMM D, YYYY")}</time></div>}
      <p className="rbr-whats-new-description">{announcement.description}</p>
      {feature && <SubscriptionRequirement feature={feature} className={feature.requirement === "texting" ? "uk-margin-small-top" : ""} />}
      <div className="hms-guest-btn">
        {feature && <Link className="uk-button hms-btn hms-red-btn uk-flex-inline uk-flex-middle" to={`/features/${feature.id}`}>Explore feature & instructions</Link>}
        {helpUrl && <a className={`uk-button hms-btn ${feature ? "hms-white-btn" : "hms-red-btn"} uk-flex-inline uk-flex-middle`} href={helpUrl} target="_blank" rel="noopener noreferrer">{feature ? "Read the full guide" : "Learn more"} ↗</a>}
        {videoUrl && <a className="uk-button hms-btn hms-white-btn uk-flex-inline uk-flex-middle" href={videoUrl} target="_blank" rel="noopener noreferrer">Watch video ↗</a>}
        {!feature && !helpUrl && <Link className="uk-button hms-btn hms-red-btn uk-flex-inline uk-flex-middle" to="/features">Explore all features →</Link>}
      </div>
      {error && <p className="rbr-discovery-error" role="alert">{error}</p>}
    </article>
  );
};

export default AnnouncementCard;
